import { Models } from "@prisma/client";
import { api } from "..";
import { store } from "../../store/store";
export type UserFiles = UserFile[];
export interface UserFile {}
function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
        (
            +c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
        ).toString(16)
    );
}
export const filesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        loadIfcFile: builder.mutation<void, File>({
            query: (file) => {
                const data = new FormData();
                data.append("file", file);
                data.append("name", file.name);
                const user_id = store.getState().auth.user?.id;
                if (user_id) {
                    data.append("user_id", user_id.toString());
                } else {
                    let temporaryUserName =
                        localStorage.getItem("temporaryUserName");
                    if (!temporaryUserName) {
                        temporaryUserName = "temporary" + uuidv4();
                        localStorage.setItem(
                            "temporaryUserName",
                            temporaryUserName
                        );
                    }
                    data.append("user_id", temporaryUserName);
                }
                return {
                    url: `/files/loadIfcFile`,
                    method: "POST",
                    body: data,
                    formData: true,
                };
            },
        }),
        getAllUserFiles: builder.query<Models[], Number | undefined>({
            query: (user_id: Number | undefined) => {
                if (!user_id && !localStorage.getItem("temporaryUserName")) {
                    localStorage.setItem(
                        "temporaryUserName",
                        "temporary" + uuidv4()
                    );
                }
                return {
                    url: user_id
                        ? `/files/getAllUserFiles`
                        : `/files/getAllUserTemporaryFiles`,
                    method: "GET",
                    params: user_id
                        ? { user_id }
                        : {
                              user_id:
                                  localStorage.getItem("temporaryUserName"),
                          },
                };
            },
        }),
        deleteFile: builder.mutation<void, string>({
            query: (model_id: string) => {
                let user_id = store.getState().auth.user?.id as any;
                if (!user_id) {
                    const local_user_id =
                        localStorage.getItem("temporaryUserName");
                    user_id = local_user_id;
                }
                return {
                    url: `/files/deleteFile`,
                    method: "GET",
                    params: { model_id, user_id },
                };
            },
        }),
        setActiveVersion: builder.mutation<void, string>({
            query: (model_id: string) => {
                let user_id = store.getState().auth.user?.id as any;
                if (!user_id) {
                    const local_user_id =
                        localStorage.getItem("temporaryUserName");
                    user_id = local_user_id;
                }
                return {
                    url: `/files/setActiveVersion`,
                    method: "GET",
                    params: { model_id, user_id },
                };
            },
        }),
        getModelName: builder.mutation<string, string>({
            query: (model_id: string) => {
                return {
                    url: `/files/getModelName`,
                    method: "GET",
                    params: { model_id },
                };
            },
        }),
    }),
});

export const {
    useLoadIfcFileMutation,
    useGetAllUserFilesQuery,
    useDeleteFileMutation,
    useGetModelNameMutation,
    useSetActiveVersionMutation,
} = filesApi;
